import PropTypes from 'prop-types';

export const answerPropType = PropTypes.shape({
  key: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  upvotes: PropTypes.number.isRequired,
  downvotes: PropTypes.number.isRequired,
  myVote: PropTypes.number.isRequired,
  justReported: PropTypes.bool.isRequired,
  best: PropTypes.bool.isRequired
}).isRequired;

export const questionPropType = PropTypes.shape({
  key: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  votes: PropTypes.number.isRequired,
  myVote: PropTypes.number.isRequired,
  justReported: PropTypes.bool.isRequired,
  answersCollapsed: PropTypes.bool.isRequired,
  answering: PropTypes.bool.isRequired,
  answers: PropTypes.arrayOf(answerPropType).isRequired
}).isRequired;
